import Vue from 'vue';
import Swiper, { Scrollbar, Navigation } from 'swiper';

Vue.component('fortuniors-benefits-slider-component', {
    props: ['totalSlides'],
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiper: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        window.addEventListener('resize', () => {
            if (window.matchMedia('(min-width: 1024px)').matches) {
                this.destroySwiper();
            } else {
                this.initSwiper();
            }
        });

        if (window.matchMedia('(min-width: 1024px)').matches) {
            this.destroySwiper();
        } else {
            this.initSwiper();
        }

        // this.initSwiper();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initSwiper() {
            this.swiper = new Swiper('.fortuniors__benefits-list', {
                // Optional parameters
                modules: [Scrollbar, Navigation],
                direction: 'horizontal',
                // loop: true,
                slidesPerView: 'auto',
                spaceBetween: 20,
                slidesOffsetAfter: 20,
                grabCursor: true,
                navigation: {
                    prevEl: '.image-carousel__navigation-prev',
                    nextEl: '.image-carousel__navigation-next',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                    },
                    1440: {
                        slidesPerView: 5,
                        spaceBetween: 5,
                    },
                },
            });
        },

        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        },

    },

    beforeDestroy() {
    },
});
